import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {RatingSelectorModule} from '../portfolio-creation/rating-selector/rating-selector.module';
import {PortfolioPreferencesPickerComponent} from './portfolio-preferences-picker.component';
import {SelectedPreferencesModule} from '../portfolio-creation/selected-preferences/selected-preferences.module';

@NgModule({
    exports: [PortfolioPreferencesPickerComponent],
    declarations: [PortfolioPreferencesPickerComponent],
    imports: [MatButtonModule, MatProgressSpinnerModule, SelectedPreferencesModule, RatingSelectorModule, CommonModule]
})
export class PortfolioPreferencesPickerModule {

}